import { EditorState } from "@codemirror/state";
import { TabParser } from "@tab-edit/model";
import { NodeBlueprint } from "./nodes/generator/blueprint";
import { ASTFragment } from "../structures/fragment";
import { PartialASTParse } from "./partial_parse";

export class ASTParser extends TabParser<ASTFragment> {
    constructor(protected blueprint: NodeBlueprint) {
        super();
    }

    createParse(
        editorState: EditorState,
        fragments: readonly ASTFragment[],
        ranges: readonly {from: number, to: number}[]
    ) {
        return new PartialASTParse(editorState, fragments || [], ranges, this.blueprint);
    }
}